<template>
  <v-app>
    <v-app-bar v-if="showTopBar" app fixed elevation="2" color="white" clipped-left>
      <v-app-bar-nav-icon v-if="showDrawer && activeMenu" v-on:click.stop="toggleDrawer" v-bind:loading="loading">
        <v-icon>{{ drawer ? "fas fa-times" : "fas fa-bars" }}</v-icon>
      </v-app-bar-nav-icon>

      <img src="./assets/logo.png" v-bind:height="titleHeight">
      <v-spacer />
      <a href="https://www.willglobalnetwork.com">
        <img src="./assets/home_small.png" v-bind:height="titleHeight - 12" class="d-sm-none">
        <img src="./assets/home.png" v-bind:height="titleHeight - 12" class="d-none d-sm-inline">
      </a>
    </v-app-bar>

    <v-navigation-drawer v-if="showDrawer" v-model="drawer" app clipped>
      <v-list dense nav class="py-1 px-2">
        <div
          v-for="menuItem in menuItems"
          v-bind:key="menuItem.title"
        >
          <v-list-item
            v-if="menuItem.if()"
            v-on:click="menuItem.onClick"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>

      <v-list class="version">
        <v-list-item
          v-if="isAdmin || currentPage == pages.LOGIN"
          v-on:click="redirect()"
          link
        >
          <v-list-item-icon>
            <v-icon>fas fa-wallet</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Financial Manager</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-3" />
        <v-list-item>
          <v-spacer />
          <v-label>v{{ appVersion }}</v-label>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-snackbar
      v-model="snackbar"
      v-bind:top="true"
      color="error"
      timeout="4000"
    >
      Cannot logout, retry later

      <template v-slot:action="{ attrs }">
        <v-btn
          v-on:click="snackbar = false"
          v-bind="attrs"
          dark
          text
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="snackbar2"
      v-bind:top="true"
      color="success"
      timeout="4000"
    >
      Password successfully changed

      <template v-slot:action="{ attrs }">
        <v-btn
          v-on:click="snackbar2 = false"
          v-bind="attrs"
          dark
          text
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="change" v-bind:width="desktop ? '60vw' : '95vw'">
      <ChangePassword
        v-if="change"
        v-on:close="change = false"
        v-on:changed="snackbar2 = true; change = false"
        class="mx-auto"
      />
    </v-dialog>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style scoped>
.version {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>

<script>
import ApiRequests from "./utils/apiRequests";
import Pages from "./utils/pages";
import ChangePassword from "./components/ChangePassword";
import UserData from "./models/UserData";

export default {
  name: "App",

  components: { ChangePassword },

  data: () => ({
    drawer: true,
    snackbar: false,
    snackbar2: false,
    pages: Pages,
    change: false
  }),

  mounted () {
    console.debug(`Willleague version: ${this.appVersion}`);

    if (this.currentPage != this.pages.PROFILE) {
      ApiRequests.currentUser(
        (result) => {
          this.$store.commit("setAdmin", result.data.isAdmin);
          this.$store.commit("setCurrentUser", UserData.create(result.data));
          this.$store.commit("setUserId", result.data._id);
        },
        () => {}
      );
    }
  },

  computed: {
    isAdmin () { return this.$store.getters.isAdmin; },
    appVersion () { return this.$store.getters.appVersion; },
    currentPage () { return this.$store.getters.currentPage; },
    activeMenu () { return this.$store.getters.activateMenuIcon; },
    loading () { return this.$store.getters.loading; },
    desktop () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs": return false;
        default: return true;
      }
    },
    showDrawer () { return this.currentPage != this.pages.SEARCH && this.currentPage != this.pages.NEW_SEARCH; },
    showTopBar () { return this.currentPage != this.pages.NEW_SEARCH; },
    menuItems () {
      return [
        {
          icon: "fas fa-user-shield",
          title: "Got to login",
          if: () => this.currentPage == this.pages.REGISTRATION,
          onClick: this.toLogin
        },
        {
          icon: "fas fa-gavel",
          title: "New user",
          if: () => this.currentPage == this.pages.LOGIN || this.currentPage == this.pages.FORGOTTEN_PWD || this.currentPage == this.pages.SEARCH,
          onClick: () => this.$router.push({ path: "/signup-page" })
        },
        {
          icon: "fas fa-user-shield",
          title: "Login",
          if: () => this.currentPage == this.pages.SEARCH,
          onClick: () => {
            this.$store.commit('setInRegistration', false);
            this.$router.push({ path: "/login" });
          }
        },
        {
          icon: "fas fa-key",
          title: "Forgot your password?",
          if: () => this.currentPage == this.pages.LOGIN,
          onClick: () => this.$router.push({ path: "/forgotten-password" })
        },
        {
          icon: "fas fa-ban",
          title: "Cancel password reset",
          if: () => this.currentPage == this.pages.FORGOTTEN_PWD,
          onClick: () => this.$router.replace({ path: "/login" })
        },
        {
          icon: "fas fa-ban",
          title: "Cancel registration",
          if: () => this.currentPage == this.pages.NEW_USER,
          onClick: () => {
            this.$store.commit("setRegisteringUser", undefined);
            this.$router.replace({ path: "/login" });
          }
        },
        {
          icon: "fas fa-edit",
          title: "Edit profile",
          if: () => this.currentPage == this.pages.PROFILE,
          onClick: this.editUser
        },
        {
          icon: "fas fa-key",
          title: "Change password",
          if: () => this.currentPage == this.pages.PROFILE || this.currentPage == this.pages.EDIT ||
            this.currentPage == this.pages.ADMIN || this.currentPage == this.pages.TEMPLATE_EDITOR ||
            this.currentPage == this.pages.DOCUMENTS || this.currentPage == this.pages.CALENDAR ||
            this.currentPage == this.pages.SCORE_CARD,
          onClick: () => this.change = true
        },
        {
          icon: "fas fa-folder",
          title: "Documents",
          if: () => this.currentPage == this.pages.PROFILE || this.currentPage == this.pages.ADMIN ||
            this.currentPage == this.pages.TEMPLATE_EDITOR || this.currentPage == this.pages.CALENDAR ||
            this.currentPage == this.pages.SCORE_CARD,
          onClick: () => this.$router.push({ path: "/documents" })
        },
        {
          icon: "fas fa-calendar-alt",
          title: "Events",
          if: () => this.currentPage == this.pages.PROFILE || this.currentPage == this.pages.ADMIN ||
            this.currentPage == this.pages.TEMPLATE_EDITOR || this.currentPage == this.pages.DOCUMENTS ||
            this.currentPage == this.pages.SCORE_CARD,
          onClick: () => this.$router.push({ path: "/calendar" })
        },
        {
          icon: "fas fa-envelope",
          title: "Email templates",
          if: () => this.currentPage == this.pages.ADMIN,
          onClick: () => this.$router.push({ path: "/email-editor" })
        },
        {
          icon: "fas fa-user",
          title: "Profile",
          if: () => this.currentPage == this.pages.TEMPLATE_EDITOR || this.currentPage == this.pages.DOCUMENTS ||
          this.currentPage == this.pages.CALENDAR || this.currentPage == this.pages.SCORE_CARD,
          onClick: () => this.$router.push({ path: "/profile" })
        },
        {
          icon: "fas fa-list-ul",
          title: "Score card",
          if: () => this.currentPage == this.pages.PROFILE || this.currentPage == this.pages.DOCUMENTS ||
          this.currentPage == this.pages.CALENDAR,
          onClick: () => this.$router.push({ path: "/score-card" })
        },
        {
          icon: "fas fa-sign-out-alt",
          title: "Logout",
          if: () => this.currentPage == this.pages.PROFILE || this.currentPage == this.pages.ADMIN ||
            this.currentPage == this.pages.TEMPLATE_EDITOR  || this.currentPage == this.pages.DOCUMENTS ||
            this.currentPage == this.pages.CALENDAR || this.currentPage == this.pages.SCORE_CARD,
          onClick: this.logoutUser
        },
        {
          icon: "fas fa-ban",
          title: "Cancel edits",
          if: () => this.currentPage == this.pages.EDIT ,
          onClick: () => {
            this.$store.commit("setRegisteringUser", undefined);
            this.$router.replace({ path: "/profile" });
          }
        }
      ];
    },
    titleHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs": return "50";
        case "sm": return "55";
        case "md": return "60";
        case "lg": return "65";
        case "xl": return "70";
        default: return "65";
      }
    },
    logoWidth () {
      return Math.ceil(this.titleHeight * 4);
    }
  },

  methods: {
    toggleDrawer () { this.drawer = !this.drawer; },
    toLogin () {
      this.$store.commit("setCurrentPage", Pages.LOGIN);
      this.$store.commit('setInRegistration', false);
    },
    editUser () {
      const tmp = this.$store.getters.currentUser.userDataObject;
      tmp._id = this.$store.getters.currentUser.id;

      this.$store.commit("setRegisteringUser", tmp);
      this.$router.push({ path: "/edit-page" });
    },
    logoutUser () {
      this.snackbar = false;
      this.toggleLoading();

      ApiRequests.logoutUser(
        () => {
          this.$store.commit("setCurrentUser", undefined);
          this.$store.commit("setUserId", undefined);
          this.$store.commit("setAdmin", false);
          this.toggleLoading();
          this.$router.replace({ path: "/login" });
        },
        (error) => {
          console.error(error);
          this.snackbar = true;
          this.toggleLoading();
        }
      );
    },
    toggleLoading () {
      this.$store.commit("setLoading", !this.loading);
    },
    loadHomePage() {
      window.location.href = "https://www.willglobalnetwork.com";
    },
    redirect() {
      window.location.href = "/admin/#/dashboard";
    }
  }
};
</script>
